/* Built In Imports */
// import NextLink from 'next/link';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Button } from '@chakra-ui/react';
import forEach from 'lodash/forEach';
import { useCookies } from 'react-cookie';

/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@app-ila/components/Utility/utils';
import config from '@config';

/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';

/* Services */

/**
 * Returns the Simple Button.
 *
 * @param style.style
 * @param {object} style - Style for button.
 * @param {string} bType - Button Type.
 * @param {string} region - Current User Country.
 * @param {string} language -
 * @param style.clickHandler
 * @param style.padding
 * @param style.textAlign
 * @param style.width
 * @param style.mb
 * @param style.mt
 * @param style.fontstyle
 * @param style.fontbold
 * @param style.extraDomains
 * @param style.disabled
 * @param style.bType
 * @param style.region
 * @param style.lang
 * @param style.target
 * @param style.minH
 * @param style.mx
 * @returns {ReactElement} SimpleButton component.
 */
export default function SimpleButton({
  style,
  bType,
  region,
  lang,
  clickHandler,
  padding,
  textAlign,
  width,
  mb,
  mt,
  fontstyle,
  mx,
  target,
  disabled = false,
  minH,
  ...props
}) {
  // const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState('');
  const cookieParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ];
  const [cookies, setCookie] = useCookies(cookieParams);
  const searchParams = useSearchParams();

  let progname = '';
  if (typeof window !== 'undefined') {
    let url = window.location.href;
    if (url.includes('/human-is-not-a-resource')) {
      progname = 'HINAR';
    } else if (url.includes('/family-enterprise-excellence')) {
      progname =
        'Family Enterprise Excellence - Mapping the Future of Your Business';
    }else if (url.includes('/insight-indepth')) {
      progname = 'Insight InDepth';
    }else if (url.includes('/insight')) {
      progname = 'INSIGHT - The DNA of Success, 2024';
    } else if (url.includes('/brand-insight')) {
      progname = 'Brand Insight - Decoding Branding';
    }else if (url.includes('/gen-a-entrepreneurship-bootcamp')) {
      progname = 'Gen A Entrepreneurship Bootcamp';
    }else if (url.includes('/harnessing-money-magic')) {
      progname = 'Harnessing Money Magic';
    }
  }

  const bookslot = (btnText) => {
    //Mixpanel
     const Mixpanel = mixPanel(window?.location.pathname);
     Mixpanel.track("sga_cta_click", {
      cta: "bottom cta",
      program_name: progname,
      element: btnText,
    });
   };

  useEffect(() => {
    // if (!router.isReady) return;
    setCurrentUrl(refineUrlDomain(style?.linkUrl, region, lang));
    setTimeout(function () {
      forEach(cookieParams, function (cookie) {
        if (searchParams?.get(cookie)) {
          setCookie(cookie, searchParams?.get(cookie), {
            path: '/',
            maxAge: 3600 * 24 * 365, // Expires after 1year
            sameSite: true,
            domain: config.COOKIE_DOMAIN,
            secure: true,
          });
        }
      });
    }, 0);
  }, [style?.linkUrl]);

  const RenderButton = ({ style }) => {
    const buttonStyle = {
      Orange: (
        <Link
          mx="auto"
          mb="30px"
          href={disabled ? '#' : currentUrl}
          variant="primary"
          textDecoration="none"
          _hover={{ textDecoration: 'none', border: 'none' }}
          _focus={{ textDecoration: 'none', border: 'none' }}
          _active={{ textDecoration: 'none', border: 'none' }}
          target={
            target ||
            (currentUrl?.indexOf('http') > -1 &&
              currentUrl?.indexOf(config.cdnPath) < 0)
              ? '_blank'
              : ''
          }
          {...props}
        >
          <Button
            fontFamily="var(--font-zilla-Slab)"
            maxW="185px"
            onClick={() => bookslot(style?.buttonText)}
            mt="15px"
            width="208px"
            h="48px"
            borderRadius="0"
            fontSize="18px"
            bg="#F27123"
            color="white"
            py="10px"
            px="15px"
            m="0 auto"
            _hover={{ bgColor: '#c76356' }}
          >
            {style?.buttonText}
          </Button>
        </Link>
      ),
    };
    return buttonStyle[style?.buttonStyle] || null;
  };

  return (
    <Box
      boxSizing="borderBox"
      display={bType ? 'flex' : 'grid'}
      placeItems={'left'}
      // as={'button'}
      color="#faf7f0"
      width={'auto'}
      // maxW={{ base: '300px', sm: '450px', md: '500px' }}
      h="auto"
      borderRadius="5px"
      fontSize={'18px'}
      textAlign="center"
      justifyContent={bType ? 'center' : ''}
      cursor="default"
      mb={(style?.buttonStyle === 'LB-Sticky-Mobile' && '0') || mb || '30px'}
      minH={
        (style?.buttonStyle === 'LB-Sticky-Mobile' && '0') || minH || '50px'
      }
      mt={
        (style?.buttonStyle === 'LB-Sticky-Mobile' && '0') || mt ? mt : '12px'
      }
      // backgroundImage="/assets/images/lb-white-texture-bg.png"
      background="transparent"
      mx={mx}
    >
      {currentUrl ? <RenderButton style={style} /> : null}
    </Box>
  );
}
